import { docReady } from '../helpers/docReady';
import { featuredIngredients, stickyAddToCart, unitPriceTags, productSubscription, buyNowPayLater } from '../snippets/product';
docReady(function () {
    buyNowPayLater();
    featuredIngredients();
    stickyAddToCart();
    unitPriceTags();
    productSubscription();
});
